import { render, staticRenderFns } from "./content-registry.vue?vue&type=template&id=d72b9c74&scoped=true&"
import script from "./content-registry.ts?vue&type=script&lang=ts&"
export * from "./content-registry.ts?vue&type=script&lang=ts&"
import style0 from "./content-registry.scss?vue&type=style&index=0&id=d72b9c74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72b9c74",
  null
  
)

export default component.exports